export const AssetScreenTranslationEN = {
  AssetScreen: {
    head_title: 'Welcome Feature',
  },
};
